import type SVGAType from 'svgaplayerweb';

export interface SvgaParams {
  node: HTMLCanvasElement | HTMLDivElement;
  dir: string;
  finish: () => void;
}

/**
 * svga 控制器
 * @example
 * const svgaPlayer = useRef<SvgaController|null>(null);
 * const node = useRef<HTMLDivElement｜HTMLCanvasElement | null>(null);
 *
 * useEffect(() => {
 *  return () => svgaPlayer.current?.dispose();
 * }, [])
 *
 * const playSvga = useCallback(() => {
 *  svgaPlayer.current = null;
 *  svgaPlayer.current = new SvgaController({
 *    node: node.current!,
 *    dir: "/svga/color-play.svga",
 *    finish: () => {
 *      console.log("finish");
 *  });
 * },[])
 */
class SvgaController {
  public player: SVGAType.Player | null = null;
  public parser: SVGAType.Parser | null = null;
  public parameters: SvgaParams | null = null;

  constructor(parameters: SvgaParams) {
    // const SVGA = await import('svgaplayerweb');
    import('svgaplayerweb').then(SVGA => {
      this.player = new SVGA.Player(parameters.node);
      this.parser = new SVGA.Parser();
      this.parameters = parameters;
      this.player.clearsAfterStop = false;
      this.init();
    });
  }

  init() {
    const _this = this;
    this.parser?.load(
      this.parameters?.dir || '',
      function (item) {
        // console.log(item, "加载成功");
        _this.player?.setVideoItem(item);
        _this.player?.startAnimation();
      },
      function (error) {
        console.log(error, 'error');
      },
    );
    /**
     * 完成时的监听
     */
    this.player?.onFrame(function (progress) {
      if (progress >= 50) {
        _this.parameters?.finish?.call(_this);
      }
    });
  }

  play() {
    this.player?.startAnimation();
  }

  stop() {
    this.player?.pauseAnimation();
  }

  dispose() {
    this.player?.clear();
  }
}

export default SvgaController;
